var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  _forEachInstanceProperty(set).call(set, function (value) {
    result[++index] = value;
  });

  return result;
}

module.exports = setToArray;